import { useEffect, useState } from "react";

export default function useOtpTimer(initial = 30) {
  const [timeLeft, setTimeLeft] = useState(initial);
  const [active, setActive] = useState(false);

  useEffect(() => {
    if (!active) return
    const interval = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          setActive(false);
          return 0;
        }
        return prev - 1
      })
    }, 1000)
    return () => clearInterval(interval)
  }, [active])

  const reset = () => {
    setTimeLeft(initial);
    setActive(true);
  };

  return { timeLeft, active, setActive, reset };
}
